export class Emitter {
    constructor() {
        this.handlers = {};
    }

    on(event, handler) {
        const handlers = this.handlers[event] || (this.handlers[event] = []);
        handlers.push(handler);
        return this;
    }

    emit(type, ...args) {
        const handlers = this.handlers[type];
        if (handlers) {
            const event = { type, target: this };
            for (const handler of handlers)
                handler(event, ...args);
        }
    }
}